import React, {Component} from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';

//CSS
import '../../LandingSubcomponents/Servicios.css';

class Promociones extends Component {
    render() {

        return (
            <Row className="promociones">
                <Col md={12}>
                    <div className="wow animated fadeIn" data-wow-duration="2s">
                        <h3>
                            ¡Conocé todas nuestras promociones del mes!
                        </h3>
                    </div>
                    <div className="wow animated fadeIn" data-wow-duration="1.5s" data-wow-delay=".5s">
                        <NavLink to="/promociones">
                            <Button className="btn-primary ">
                                Ingresá
                            </Button>
                        </NavLink>
                    </div>
                </Col>
            </Row>
        );
    }
}


export default Promociones;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Servicios/Promociones.js